export default "__VITE_ASSET__030739f3__"